module.exports = __webpack_public_path__ + "88ce794100e74a9e114910356b222e3c.png";